<nav class="navbar navbar-dark navbar-gradient px-3" *ngIf="auth.isLoggedIn">
  <div
    class="container-fluid d-flex justify-content-between align-items-center flex-nowrap"
  >
    <!-- Brand / Logo -->
    <a
      class="navbar-brand fw-bold mb-0 d-flex align-items-center"
      routerLink="/public-schedule"
    >
      <i class="bi bi-calendar3-week me-2"></i>
      <span class="text-truncate">ScheduleMaker</span>
    </a>

    <!-- Offcanvas toggle button -->
    <button
      class="navbar-toggler ms-2 flex-shrink-0"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasNavbar"
      aria-controls="offcanvasNavbar"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>

  <!-- Offcanvas Menu -->
  <div
    class="offcanvas offcanvas-end text-bg-dark"
    tabindex="-1"
    id="offcanvasNavbar"
    aria-labelledby="offcanvasNavbarLabel"
  >
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasNavbarLabel">
        <i class="bi bi-person-circle me-2"></i>
        {{ auth.getUserName() || "User" }}
      </h5>
      <button
        type="button"
        class="btn-close btn-close-white"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>

    <div class="offcanvas-body">
      <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
        <!-- 📅 SCHEDULE (Everyone can see) -->
        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/public-schedule"
            data-bs-dismiss="offcanvas"
          >
            <i class="bi bi-calendar-event me-2"></i>Schedule
          </a>
        </li>

        <!-- ✋ EMPLOYEE-ONLY SECTION (Not spectators) -->
        <ng-container *ngIf="isEmployee || auth.isManager || auth.isAdmin">
          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="/timesheet"
              data-bs-dismiss="offcanvas"
            >
              <i class="bi bi-clock-history me-2"></i>Timesheet
            </a>
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="/requests"
              data-bs-dismiss="offcanvas"
            >
              <i class="bi bi-calendar-x me-2"></i>Request Days Off
            </a>
          </li>

          <li class="nav-item">
            <a
              class="nav-link d-flex justify-content-between align-items-center"
              routerLink="/shift-swap"
              data-bs-dismiss="offcanvas"
            >
              <span>
                <i class="bi bi-arrow-left-right me-2"></i>Request Shift Swap
              </span>
              <span
                *ngIf="pendingSwapCount > 0"
                class="badge rounded-pill bg-danger ms-2"
                style="font-size: 0.75rem"
              >
                {{ pendingSwapCount }}
              </span>
            </a>
          </li>
        </ng-container>

        <!-- ⚙️ SETTINGS (Everyone except spectators) -->
        <li
          class="nav-item"
          *ngIf="isEmployee || auth.isManager || auth.isAdmin || isSpectator"
        >
          <a
            class="nav-link"
            routerLink="/settings"
            data-bs-dismiss="offcanvas"
          >
            <i class="bi bi-gear me-2"></i>Settings
          </a>
        </li>

        <!-- 👔 MANAGER SECTION (Only managers and admins) -->
        <ng-container *ngIf="auth.isManager || auth.isAdmin">
          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="/manager"
              data-bs-dismiss="offcanvas"
            >
              <i class="bi bi-clipboard-data me-2"></i>Management Dashboard
            </a>
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="/schedule"
              data-bs-dismiss="offcanvas"
            >
              <i class="bi bi-table me-2"></i>Create New Schedule
            </a>
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="/manager/timesheets"
              data-bs-dismiss="offcanvas"
            >
              <i class="bi bi-clock-history me-2"></i>Manage Timesheets
            </a>
          </li>
        </ng-container>

        <!-- 🛡️ ADMIN SECTION (Only admins) -->
        <ng-container *ngIf="auth.isAdmin">
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin" data-bs-dismiss="offcanvas">
              <i class="bi bi-shield-lock me-2"></i>Admin Panel
            </a>
          </li>
        </ng-container>

        <!-- 🚪 LOGOUT (Everyone) -->
        <li class="nav-item mt-3">
          <hr class="dropdown-divider bg-secondary" />
        </li>

        <li class="nav-item">
          <a
            class="nav-link text-danger"
            routerLink="/login"
            (click)="auth.clearUser()"
            data-bs-dismiss="offcanvas"
          >
            <i class="bi bi-box-arrow-right me-2"></i>Logout
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>

<div
  *ngIf="showUpdateBanner"
  class="update-banner"
  role="status"
  aria-live="polite"
>
  <div class="update-banner__content">
    <div class="update-banner__text">
      <span class="update-banner__title">A new version is available</span>
      <span class="update-banner__message"
        >Tap update to load the latest changes.</span
      >
    </div>
    <div class="update-banner__actions">
      <button
        type="button"
        class="btn btn-sm update-banner__button"
        (click)="applyUpdate()"
      >
        Update Now
      </button>
      <button
        type="button"
        class="btn-close btn-close-white update-banner__close"
        (click)="dismissUpdateBanner()"
        aria-label="Dismiss update notice"
      ></button>
    </div>
  </div>
</div>

<div class="container py-4 app-content">
  <!-- Multi-Purpose Banner Notification -->
  <div
    *ngIf="showBanner"
    class="banner-notification mb-4"
    [ngClass]="bannerConfig.type"
    role="alert"
  >
    <div class="d-flex align-items-start">
      <i [class]="bannerConfig.icon + ' me-3 fs-4'"></i>
      <div class="flex-grow-1">
        <h6 class="banner-heading mb-2">
          <strong>{{ bannerConfig.title }}</strong>
        </h6>
        <!-- Changed from {{ }} to [innerHTML] to render HTML -->
        <p class="mb-2" [innerHTML]="bannerConfig.message"></p>
        <button
          *ngIf="bannerConfig.actionButton"
          class="btn btn-sm"
          [ngClass]="bannerConfig.buttonClass"
          (click)="handleBannerAction()"
        >
          <i [class]="bannerConfig.buttonIcon + ' me-1 text-white'"></i>
          {{ bannerConfig.actionButton }}
        </button>
      </div>
      <button
        type="button"
        class="btn-close"
        (click)="dismissBanner()"
        aria-label="Close"
      ></button>
    </div>
  </div>

  <router-outlet></router-outlet>
</div>

<div class="app-version-label" aria-hidden="true">v1.1.2</div>
